<template>
	<BaseContenedor>
		<BaseButton
			v-puede-disabled="[roles.Administrador]"
			style-button="positive"
			style-class="right floated positive"
			@click="toggleModalArchivo"
		>
			<i class="file alternate outline icon"></i>
			Importar
		</BaseButton>
		<BaseButton
			v-puede-disabled="[roles.Administrador]"
			style-button="primary"
			style-class="right floated"
			@click="toggleModal"
		>
			<i class="plus icon"></i>
			Agregar
		</BaseButton>
		<BaseModalArchivo
			ref="modal-archivo"
			v-model="files"
			titulo="Importar banco de preguntas"
			:loading="getLoadingAction"
			acepta=".docx"
			@close="toggleModalArchivo"
			@aceptar="subirArchivos"
		/>
		<AgregarBancoDePreguntas
			ref="exam"
			v-model="bancoDePreguntas"
			:editar="editar"
			:loading="getLoadingAction"
			@guardar="onCrear"
			@editar="onEditar"
		></AgregarBancoDePreguntas>
		<br />
		<br />
		<br />
		<div
			v-if="getBancosDePreguntas.length === 0"
			class="sixteen wide column"
			style=" padding:2em;text-align:center;"
		>
			<h2>Sin bancos de preguntas registrados</h2>
		</div>
		<div class="ui four stackable cards">
			<div v-for="item in getBancosDePreguntas" :key="item.clave" class="card">
				<div class="content grid">
					<router-link
						:key="item.clave"
						:to="`/bancosDePreguntas/detalle/${item.clave}`"
						@click.native="establecerBancoDePreguntas(item)"
					>
						<sui-popup :content="item.nombreCompleto" inverted>
							<sui-icon
								slot="trigger"
								circular
								name="tiny info"
								:class="$style.topright"
							/>
						</sui-popup>
						<h3 class="image" style="font-size:80px;text-align: center">
							<img class="ui tiny image" :src="buildLogoUrl('materias.svg')" />
						</h3>
						<div>
							<span class="header boldFont" :class="$style.titulo">
								{{ item.clave }}
								{{ item.nombreCompleto }}
							</span>
						</div>
					</router-link>
				</div>
				<div class="extra content" @click.stop>
					<div class="ui two buttons">
						<button
							v-puede-disabled="[roles.Administrador]"
							class="ui basic primary vertical animated button"
							@click="editarClick(item)"
						>
							<div class="hidden content">Editar</div>
							<div class="visible content">
								<i class="edit icon"></i>
							</div>
						</button>
						<button
							v-puede-disabled="[roles.Administrador]"
							class="ui basic red vertical animated button"
							@click="onEliminar(item)"
						>
							<div class="hidden content">Eliminar</div>
							<div class="visible content">
								<i class="trash icon"></i>
							</div>
						</button>
					</div>
				</div>
				<div></div>
			</div>
		</div>
	</BaseContenedor>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AgregarBancoDePreguntas from './agregar-banco.vue';
import { dateTimeInputTextToServer } from '@utils/format-date';
import Notification from '../../../utils/notification';
import Rols from '@constants/roles';
import Vue from 'vue';

export default {
	components: { AgregarBancoDePreguntas },
	data() {
		return {
			files: [],
			bancoDePreguntas: {},
			editar: false,
			roles: Rols
		};
	},
	computed: {
		...mapGetters('bancosDePreguntas', [
			'getBancosDePreguntas',
			'getLoadingAction'
		])
	},
	mounted() {
		this.establecerTitulo('Bancos de preguntas');
		this.establecerUrlAtras('/');
		this.inicializar();
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('bancosDePreguntas', [
			'inicializar',
			'obtenerBancoDePreguntas',
			'crearBancoDePreguntas',
			'establecerBancoDePreguntas',
			'editarEncabezado',
			'eliminarBancoDePreguntas',
			'subirArchivoDocx'
		]),
		...mapActions('bancosDePreguntas', ['obtenerBancoDePreguntas']),
		buildLogoUrl(name) {
			return require('../../../assets/images/' + name);
		},
		toggleModalArchivo() {
			this.$refs['modal-archivo'].toggle();
		},
		closeModalArchivo() {
			this.$refs['modal-archivo'].close();
		},
		toggleModal() {
			this.editar = false;
			this.$refs.exam.toggle();
		},
		onCrear() {
			const exa = {
				clave: this.bancoDePreguntas.clave,
				nombreCompleto: this.bancoDePreguntas.nombreCompleto,
				fechaYHoraInicio: dateTimeInputTextToServer(
					this.bancoDePreguntas.fechaInicio,
					this.bancoDePreguntas.horaInicio
				),
				introduccion: this.bancoDePreguntas.introduccion
			};
			this.crearBancoDePreguntas({
				params: exa,
				onComplete: () => {
					this.$refs.exam.close();
					Notification('success', '¡Banco de preguntas creado con éxito!');
					setTimeout(() => this.inicializar(), 2000);
				}
			});
		},
		editarClick(bancoDePreguntas) {
			this.establecerBancoDePreguntas(bancoDePreguntas);
			this.editar = true;
			this.$refs.exam.toggle();
		},
		onEditar() {
			const exa = {
				nombreCompleto: this.bancoDePreguntas.nombreCompleto
			};
			this.editarEncabezado({
				clave: this.bancoDePreguntas.clave,
				params: exa,
				onComplete: () => {
					this.$refs.exam.close();
					Notification('success', '¡Banco de preguntas modificado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		onEliminar(item) {
			this.$confirm({
				title: 'Eliminar banco de preguntas',
				message: '¿Desea eliminar el banco de preguntas seleccionado?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarBancoDePreguntas({
						clave: item.clave,
						onComplete: () => {
							closeModal();
							Notification(
								'success',
								'¡Banco de preguntas eliminado con éxito!'
							);
							setTimeout(() => this.inicializar(), 1000);
						},
						onError: () =>
							Notification('error', 'Error al eliminar el banco de preguntas')
					});
				},
				callbackCancelar: () => {}
			});
		},
		subirArchivos() {
			if (this.files.length > 0) {
				this.subirArchivoDocx({
					archivos: this.files[0],
					onComplete: () => {
						Notification('info', 'Procesando información');
						this.closeModalArchivo();
						setTimeout(() => this.inicializar(), 2000);
					}
				});
				Vue.set(this, 'files', []);
			}
		}
	}
};
</script>

<style lang="scss" module>
.topright {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 0.6em !important;
	color: #fff;
	background-color: #cacbcd;
}
.titulo {
	font-size: 18px;
	font-weight: bold;
	color: #5c5d5d;
}
</style>
